import React from "react";
import { Card, Spinner } from "react-bootstrap";

/**
 * Componente de estado vacío para mostrar mensajes contextuales
 */
const EmptyState = ({
  icon,
  title,
  message,
  isLoading = false,
  className = "",
  style = {},
}) => {
  const defaultStyle = {
    minHeight: "40vh",
    ...style,
  };

  return (
    <Card className={`mt-3 text-center py-5 ${className}`} style={style}>
      <Card.Body
        className="d-flex flex-column align-items-center justify-content-center"
        style={defaultStyle}
      >
        {isLoading ? (
          <>
            <Spinner
              animation="border"
              variant="primary"
              style={{
                width: "4rem",
                height: "4rem",
                marginBottom: "1.5rem",
              }}
            />
            <h4 className="text-primary mb-3">Cargando datos...</h4>
            <p className="text-muted mb-0 w-75">
              Estamos procesando su solicitud, por favor, espere un momento.
            </p>
          </>
        ) : (
          <>
            <div className="mb-3 text-muted" style={{ fontSize: "4rem" }}>
              {icon || <i className="far fa-calendar-alt"></i>}
            </div>
            <h4 className="mb-3">{title}</h4>
            <p className="text-muted mb-0 w-75">{message}</p>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

// ✅ COMPONENTES ESPECÍFICOS PRE-CONFIGURADOS
export const WelcomeEmptyState = ({ reportType = "alertas" }) => (
  <EmptyState
    icon={<i className="fas fa-search"></i>}
    title={`Bienvenido al reporte de ${(reportType || "").toLocaleLowerCase()}`}
    message={`Establezca los parámetros de búsqueda en los filtros y haga clic en el botón generar para obtener el reporte.`}
  />
);

export const LoadingEmptyState = ({
  message = "Estamos procesando tu solicitud, esto puede tomar unos momentos.",
}) => <EmptyState isLoading={true} message={message} />;

export const NoDataEmptyState = ({
  reportType = "gps",
  entityType = "alertas",
}) => {
  const getIcon = () => {
    switch (reportType) {
      case "gps":
        return <i className="fas fa-satellite-dish"></i>;
      case "camara":
        return <i className="fas fa-camera"></i>;
      case "omisiones":
        return <i className="fas fa-ban"></i>;
      default:
        return <i className="fas fa-exclamation-triangle"></i>;
    }
  };

  const getTypeLabel = () => {
    switch (reportType) {
      case "gps":
        return "GPS";
      case "camara":
        return "Inteligencia Artificial";
      case "omisiones":
        return "Omisiones";
      default:
        return reportType;
    }
  };

  return (
    <EmptyState
      icon={getIcon()}
      title={"No se obtuvieron resultados con los parámetros actuales"}
      message={"Le recomendamos ajustar los filtros y realizar una nueva búsqueda."}
    />
  );
};

export const NoSelectionEmptyState = ({
  reportType = "gps",
  entityType = "alertas",
}) => {
  const getIcon = () => {
    switch (reportType) {
      case "gps":
        return <i className="fas fa-map-marker-alt"></i>;
      case "camara":
        return <i className="fas fa-video"></i>;
      case "omisiones":
        return <i className="fas fa-exclamation-triangle"></i>;
      default:
        return <i className="fas fa-filter"></i>;
    }
  };

  const getTypeLabel = () => {
    switch (reportType) {
      case "gps":
        return "alertas GPS";
      case "camara":
        return "alertas IA";
      case "omisiones":
        return "omisiones";
      default:
        return entityType;
    }
  };

  return (
    <EmptyState
      icon={getIcon()}
      title="Selecciona vehículos y tipos de alertas"
      message={`Para visualizar el reporte de ${getTypeLabel()}, usa los filtros superiores para seleccionar vehículos y tipos de ${entityType}.`}
    />
  );
};

export default EmptyState;
